<template>
  <div class="home" style="min-height:500px;">

    <div style="margin-bottom:30px;">
    Le chiediamo di inserire il codice di consultazione del suo abstract. 
    </div>
    <el-form ref="isAbs" :model="abs" v-on:submit.prevent="onConsulta" :rules="rules" label-width="180px">

        <el-form-item :label="$teras.lang.codiceconsultazione" prop="codiceconsultazione">
            <el-input  v-model="abs.codiceconsultazione"></el-input>
        </el-form-item>




   <div class="row " style="margin-top:40px;">
    <div class="col s12 m3">&#160;</div>
    <div class="col s12 m6"><el-button type="primary" @click="onConsulta" style="width:100%;">Procedi</el-button></div>
    <div class="col s12 m3"></div>
  </div>
    </el-form>

    <div v-if="esito">
    <h4 class="yo-color-secondary" v-html="$teras.lang.esito"></h4>
    <div v-html="html" />
    </div>

  </div>
</template>

<script>

var moment = require('moment')

export default {
  data () {
    return {
        rules:{
            codiceconsultazione: [
          { required: true, message: this.$teras.lang.eRequired.codiceconsultazione, trigger: 'blur' }
        ]
        }
      ,abs:{
          codiceconsultazione:''
      }
      ,esito:false
      ,html:''
    }
  },
  created(){
    
  },
  mounted(){
    
  },
  methods: {
    onConsulta(){
      //this.$teras.appReady = false
        this.esito = false
        this.html = ''

      this.$refs.isAbs.validate((valid) => {
          if (valid ) {
            var parent = this
            this.axios.query('fetchRow','SELECT * FROM abstract WHERE codice= →codiceconsultazione',{codiceconsultazione:this.abs.codiceconsultazione}).then(function (data) {
                console.log('§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§§ù')
                console.log(typeof data.result)
                console.log(data.result)
                if(typeof data.result == 'object'){
                    parent.getHtml(data.result.id)
                }else{
                    parent.$notify.error({title: 'Errore', message: 'Il tuo abstract non è stato trovato!' })
                }
            }) 
          } else {
            this.$notify.error({title: 'Errore', message: 'Non tutti i dati sono stati inseriti correttamente!' })
          }
        })
    },
    getHtml(id){
        var args = {idAbs: id, sendto:'', lingua:'ita'}
        this.axios.post(this.axios.apiUrl+'vue/soap',{url:'http://tomcat:8080/j-bvent/services/Ws?wsdl',action:'bamsPaginaConsultazione',args: args}).then((response) => {
            console.log('******************************RESPONSE')
            this.html = response.data.data.result.altro
            this.esito = true
            console.log(response.data.data.result.altro)
            })
            .catch(function (error) {
            console.log('ERRORE..............................')
            console.log(response)
            })

    }
  }
}
</script>


<style scoped>
.combustion div.el-carousel__container {
  height: 440px !important;
  border:10px solid red;
  width: 500px;
}
.home a.btn{
  display:block;
  width: 100%;
  height: 3.8rem;
  color:#ffffff;
  text-align: center;
  line-height: 3.8rem;
  font-size: 1.8rem;
  font-weight: bold;
  background: darkred;
  border-color: darkred;
}.home a.main{
  display:block;
  font-size:2.3rem;
  text-align: center;
  color:darkred;
  font-weight: bold;
  padding:20px 0;
}
</style>



// WEBPACK FOOTER //
// Abs-consulta.vue?42bf27d3